import { THeadingTreeNode } from '../types';

/**
 * Returns all descendant IDs (children, grandchildren, etc.) of a given heading `rootId`.
 * We do a simple DFS/BFS on `treeHeadings`.
 */
export default function getAllDescendants(rootId: string, treeHeadings: THeadingTreeNode[]): Set<string> {
  const result = new Set<string>();

  // First, find the node that matches `rootId` in `treeHeadings`
  const stack = [...treeHeadings];

  let rootNode: THeadingTreeNode | undefined = undefined;
  while (stack.length > 0) {
    const node = stack.pop()!;
    if (node.id === rootId) {
      rootNode = node;
      break;
    }
    stack.push(...node.children);
  }
  if (!rootNode) return result; // if we didn't find it, return empty set

  // Now gather all descendants from `rootNode`
  const queue = [...rootNode.children];
  while (queue.length > 0) {
    const child = queue.shift()!;
    result.add(child.id);
    queue.push(...child.children);
  }

  return result;
}
